
import useAccount from "@/composables/useAccount";
import useVuelidate from "@vuelidate/core";
import { helpers, maxLength, minLength, required } from "@vuelidate/validators";
import { defineComponent, reactive, ref } from "vue";
import AccountSetting from "./AccountSetting.vue";
import AccountSettingsSection from "./AccountSettingsSection.vue";

export default defineComponent({
	components: { AccountSettingsSection, AccountSetting },
	setup() {
		const { updatePassword } = useAccount();
		const loading = ref(false);
		const settingsSectionRef = ref();
		const state = reactive({
			password: "",
			passwordConfirm: "",
		});

		const rules = {
			password: {
				required,
				min: helpers.withMessage(() => "Minimum 6 characters", minLength(6)),
				max: helpers.withMessage(() => "Maximum 10 characters", maxLength(10)),
			},
			passwordConfirm: {
				v: helpers.withMessage(
					() => "Passwords do not match",
					(value: string) => value === state.password
				),
			},
		};

		const v$ = useVuelidate(rules, state);

		const submit = async () => {
			const valid = await v$.value.$validate();
			if (valid) {
				loading.value = true;
				updatePassword(state.password, state.passwordConfirm)
					.then(() => settingsSectionRef.value.toggle())
					.finally(() => (loading.value = false));
			}
		};

		return { v$, submit, loading, settingsSectionRef };
	},
});
